module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-3.17157e54.jpg";